import React from 'react';
import styles from './ActivationListItem.module.scss';
import { Activation } from '../../../models/activation';
import { RbacPermissions } from '../../../../../core/interfaces/user';
import { getCalendarDateWithTimezone } from '../../../../../date-time/utils/date';
import { HdTooltip } from '../../../../../components';
import { WorkflowDependentExecutionPolicy } from '../../../../scheduler/WorkflowDependentExecutionPolicy';
import { ActivationNodeRelation } from '../../../ActivationNodeRelation/ActivationNodeRelation';
import { PlayButtonV1 } from '../../../../../button/components/play-button-v1/PlayButtonV1';
import { useMemoizedDataIds } from '../../../../../core/utils/generateDataId';
import { HeaderIdBadge } from '../../../../../shared/components/listing-id-badge/ListingIdBadge';

interface ActivationListItemProps {
  activation: Activation;
  pauseActivation: Function;
  resumeActivation: Function;
  dataId: string;
}
export const ActivationListItem = React.memo<ActivationListItemProps>(
  ({ activation, pauseActivation, resumeActivation, dataId }) => {
    const dataIds = useMemoizedDataIds(
      {
        base: '',
        playBtn: 'play'
      },
      dataId
    );

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getPolicyMessage = (activation: Activation): string =>
      `Every ${activation.executionPolicy.frequencyValue} ${activation.executionPolicy.frequencyType.name}`;

    return (
      <>
        <HeaderIdBadge id={activation.seqId} size='md' />

        <div className={styles.activateListItemC1}>
          <div className='center-flex-row'>
            <HdTooltip enableOnTextOverflow title={activation.name}>
              <div className='text-subheading-2 text-ellipsis'>{activation.name}</div>
            </HdTooltip>

            <div className={styles.activateLastRun}>
              <span className='mx-2'>&bull;</span>
              Last Run:{' '}
              {activation.lastRun?.transformationRunStats?.startedTs
                ? getCalendarDateWithTimezone(activation.lastRun?.transformationRunStats?.startedTs)
                : 'Not run yet'}
            </div>
          </div>

          <ActivationNodeRelation activation={activation} className='mt-1' />
        </div>

        <div className={styles.activateListItemC2}>
          <div className='center-flex-row'>
            <HdTooltip
              enableOnTextOverflow
              title={
                <span className='text-normal text-transform-none'>{activation.status.name}</span>
              }
            >
              <span className={`badge badge-solid-faded ${activation.status.colorType}-badge`}>
                {activation.status.name}
              </span>
            </HdTooltip>

            <div className='ml-2'>
              <PlayButtonV1
                dataId={dataIds.playBtn}
                rbacPermission={RbacPermissions.ACTIVATION_EDIT}
                iconOnly
                disabled={false}
                paused={activation.state.value === 'PAUSED'}
                pause={() => pauseActivation(activation)}
                resume={() => resumeActivation(activation)}
              />
            </div>
          </div>
          {!activation.independentRunStatus.runsOnlyInWorkflows ? (
            <HdTooltip
              enableOnTextOverflow
              zIndex={1305}
              className=' text-ellipsis'
              title={getPolicyMessage(activation)}
            >
              <div className='execution-policy mt-2'>
                <span className='text-secondary'>Runs </span>
                {getPolicyMessage(activation)}
              </div>
            </HdTooltip>
          ) : (
            <WorkflowDependentExecutionPolicy
              independentRunStatus={activation.independentRunStatus}
            />
          )}
        </div>
      </>
    );
  }
);
